import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import UserContext, { User } from "../contexts/UserContext";
import { navigate, Link } from "gatsby";

const SignupPage: React.FC = () => {
  const { register, handleSubmit, errors } = useForm();
  const { setUser } = useContext(UserContext);

  const onSubmit = async (data: {
    Username: string;
    Email: string;
    Password: string;
  }) => {
    try {
      const response = (await axios.post(
        `${process.env.GATSBY_STRAPI_URL}/auth/local/register`,
        {
          username: data.Username,
          email: data.Email,
          password: data.Password,
        }
      )) as { data: { user: string; jwt: string } };
      console.log("utilisateur créé");
      console.log("User profile", response.data.user);
      console.log("User token", response.data.jwt);
      const strapiUser = response.data.user;
      const signedUser: User = {
        id: strapiUser["id"],
        username: strapiUser["username"],
        email: strapiUser["email"],
        token: response.data.jwt,
      };
      setUser(signedUser);
      navigate("/booking");
    } catch (error) {
      console.log(error);
    }
  };
  console.log(errors);

  return (
    <div className="w-screen h-screen bg-gray-500 flex flex-col justify-center items-center">
      <div className="w-4/5 h-auto bg-white p-4">
        <div>S'enregistrer</div>
        <form
          className="flex h-full flex-col mt-4"
          onSubmit={handleSubmit(onSubmit)}
        >
          <input
            className="mt-4 p-2 focus:outline-none focus:border-2"
            type="text"
            placeholder="Username"
            name="Username"
            ref={register}
          />
          <input
            className="mt-4 p-2"
            type="text"
            placeholder="Email"
            name="Email"
            ref={register({ required: true, pattern: /^\S+@\S+$/i })}
          />
          <input
            className="mt-4 p-2"
            type="password"
            placeholder="Password"
            name="Password"
            ref={register({ required: true })}
          />
          {errors.errorMessage && errors.errorMessage.message}
          <Link to="/signin" className="mt-4">
            Se connecter
          </Link>
          <input className="mt-6 p-2" type="submit" />
        </form>
      </div>
    </div>
  );
};

export default SignupPage;
